export default (
  state = {
    inbox: {},
  },
  action,
) => {
  switch (action.type) {
    case "INBOX_INIT_DATA":
      return {
        ...state,
        inbox: action.payload,
      };
    case "FETCH_INBOX_NOTIFICATIONS_ON_SCROLL": {
      return {
        ...state,
        inbox: action.payload,
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/InboxReducer.js